import { serviceAgreementApi } from 'api';

export const withdrawModificationDataApi = async (serviceAgreementId: string) => {
  return await serviceAgreementApi.abortServiceAgreementModification({
    serviceAgreementUid: serviceAgreementId,
  });
};
